import { render, staticRenderFns } from "./newaffairs.vue?vue&type=template&id=dca0bcd2&scoped=true&"
import script from "./newaffairs.vue?vue&type=script&lang=js&"
export * from "./newaffairs.vue?vue&type=script&lang=js&"
import style0 from "./newaffairs.vue?vue&type=style&index=0&id=dca0bcd2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca0bcd2",
  null
  
)

export default component.exports